import { Flex } from "antd";
import TextArea from "antd/es/input/TextArea";
import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { StyledSBMRaw } from "../../Styled";

interface InvoiceCommentProps {
    comments: string[];
}

export const InvoiceComment: FC<InvoiceCommentProps> = ({ comments }) => {
    if (!comments?.length) return null;

    return (
        <StyledSBMRaw $columns={1}>
            <Flex vertical gap={8}>
                <PrimaryText>Коментар</PrimaryText>

                <TextArea
                    disabled
                    value={comments.join("\n")}
                    readOnly
                    rows={4}
                    style={{ resize: "none" }}
                />
            </Flex>
        </StyledSBMRaw>
    );
};
